/* Product page: gallery switching, and keeping the hidden variant id,
   price and submit button in step with the option controls.

   Handles both picker styles — radio pills and dropdowns — by reading
   data-option-index off whichever control is present, so the same code
   serves either setting without branching. */
(function () {
  // --- gallery ---------------------------------------------------------

  var gallery = document.querySelector('[data-gallery]');

  if (gallery) {
    var frames = gallery.querySelectorAll('[data-gallery-frame]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');

    function showFrame(index) {
      frames.forEach(function (frame) {
        var active = frame.getAttribute('data-index') === String(index);
        frame.classList.toggle('is-active', active);
        if (active) frame.removeAttribute('aria-hidden');
        else frame.setAttribute('aria-hidden', 'true');
      });

      thumbs.forEach(function (thumb) {
        thumb.classList.toggle('is-active', thumb.getAttribute('data-index') === String(index));
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showFrame(thumb.getAttribute('data-index'));
      });
    });

    // Variant images: selecting a variant that has its own media jumps
    // the gallery to it, which is what a shopper expects after picking
    // a different size or bottle.
    gallery.addEventListener('pb:variant', function (event) {
      var mediaId = event.detail && event.detail.mediaId;
      if (!mediaId) return;

      var match = gallery.querySelector('[data-gallery-frame][data-media-id="' + mediaId + '"]');
      if (match) showFrame(match.getAttribute('data-index'));
    });
  }

  // --- variants --------------------------------------------------------

  var dataEl = document.getElementById('PbVariants');
  var form = document.getElementById('PbProductForm');
  if (!dataEl || !form) return;

  var variants;
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch (error) {
    return;
  }
  if (!Array.isArray(variants) || !variants.length) return;

  var picker = document.querySelector('[data-picker]');
  var input = form.querySelector('[data-variant-input]');
  var submit = form.querySelector('.pb-pdp__submit');
  var buyNowBtn = form.querySelector('[data-buy-now]');
  var priceEl = document.querySelector('.pb-pdp__price-current');

  // A single-variant product renders no picker at all — quantity and buy
  // now still need to work there, so only the option-sync logic below is
  // gated on one existing.
  if (picker) {
    var readOptions = function () {
      var values = [];

      // Radios report only the checked one; selects report their value.
      picker.querySelectorAll('select[data-option-index]').forEach(function (select) {
        values[parseInt(select.getAttribute('data-option-index'), 10)] = select.value;
      });
      picker.querySelectorAll('input[type="radio"][data-option-index]:checked').forEach(function (radio) {
        values[parseInt(radio.getAttribute('data-option-index'), 10)] = radio.value;
      });

      return values;
    };

    var findVariant = function (values) {
      return variants.filter(function (variant) {
        return values.every(function (value, index) {
          return variant.options[index] === value;
        });
      })[0];
    };

    var update = function () {
      var values = readOptions();
      var variant = findVariant(values);

      // Keep the "Size: 100ml" style legend in step with the chosen pill.
      values.forEach(function (value, index) {
        var label = picker.querySelector('[data-selected-for="' + index + '"]');
        if (label) label.textContent = value;
      });

      if (!variant) {
        if (submit) {
          submit.disabled = true;
          submit.textContent = submit.getAttribute('data-sold-label') || submit.textContent;
        }
        if (buyNowBtn) buyNowBtn.disabled = true;
        return;
      }

      if (input) input.value = variant.id;

      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available
          ? submit.getAttribute('data-add-label')
          : submit.getAttribute('data-sold-label');
      }

      if (buyNowBtn) buyNowBtn.disabled = !variant.available;

      if (priceEl && typeof variant.price === 'number') {
        // Shopify sends prices in cents; render with the shop's own format
        // where available rather than assuming a currency symbol.
        var amount = (variant.price / 100).toFixed(2);
        priceEl.textContent = priceEl.textContent.replace(/[\d.,]+/, amount);
      }

      if (gallery && variant.featured_media) {
        gallery.dispatchEvent(
          new CustomEvent('pb:variant', { detail: { mediaId: variant.featured_media.id } })
        );
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    picker.addEventListener('change', update);
  }

  // --- quantity stepper --------------------------------------------------

  var qtyInput = form.querySelector('.pb-qty__input');
  var qtyMinus = form.querySelector('[data-qty-minus]');
  var qtyPlus = form.querySelector('[data-qty-plus]');

  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', function () {
      var value = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = Math.max(1, value - 1);
    });

    qtyPlus.addEventListener('click', function () {
      var value = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = value + 1;
    });
  }

  // --- buy now -------------------------------------------------------------

  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function () {
      buyNowBtn.setAttribute('aria-busy', 'true');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw new Error(data.description || data.message);
            return data;
          });
        })
        .then(function () {
          window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'checkout';
        })
        .catch(function (error) {
          window.alert(error.message);
          buyNowBtn.removeAttribute('aria-busy');
        });
    });
  }
})();
